export const SUPPORT_EMAIL = 'support@fruitful.com';
